export default __webpack_public_path__ + "static/media/Arvind Limited .92ffd095.jpg";